import { Component, HostListener, OnInit, AfterViewInit, ElementRef, Renderer2, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import cjson from 'compressed-json';
import { Location } from '@angular/common';



@Component({
    selector: 'app-webbtree-company-list',
    templateUrl: './webbtree-company-list.component.html',
    styleUrls: ['./webbtree-company-list.component.scss'],
    providers: [{ provide: NgbActiveModal, useValue: {} }],
    standalone: false
})
export class WebbtreeCompanyListComponent implements OnInit {
  /**Industry typeahead lists */
  industry_typeaheads: any[] = [];
  /**Compny sizes typeahead lists */
  companysizes_typeaheads: any[] = [];
  /** Location typeahead lists */
  location_typeaheads: any[] = [];
  companiesList: any[] = [];
  companyBucketName: string = '';
  industrySelectedChips: string[] = [];
  companySizesSelectedChips: string[] = [];
  fortuneFilterClick: boolean = true;
  locationSelectedChips: string[] = [];
  searchValue: string;
  subscriptions: Array<Subscription> = [];
  btnCompareClicked: boolean = false
  btnCompareClicked2: boolean = false
  start: number = 0;
  totalCompanies: number = 0;
  showCompanyListLoader: boolean = false;
  unicornFilterClick: boolean = false;
  showFooter: boolean = false
  filterObj: any = {};
  resultsize: number = 21
  isCollapsed = false;
  @ViewChild('sidebar') sidebar!: ElementRef;
  @ViewChild('stopper') stopper!: ElementRef;
  private observer!: IntersectionObserver;
  searchFrom: string;

  constructor(private CompanyInsightsService: CompanyInsightsService, private localStorageService: LocalStorageService, private renderer: Renderer2,
    private location: Location, private router: Router, private route: ActivatedRoute
  ) {
    this.companyBucketName = 'Fortune500';
     const cacheRequest = localStorage.getItem(this.route.snapshot.queryParams.filter);
    const filterData = cjson.decompress(JSON.parse(cacheRequest));
    this.loadDataFromLocalStorage(filterData);
    const statemanagementSub = this.location.subscribe((p) => {
        const filterKey = this.getFilterKeyFromUrl();
           if (filterKey) {
             const cached = localStorage.getItem(filterKey);
             const filterData = cjson.decompress(JSON.parse(cached));
           this.loadDataFromLocalStorage(filterData);
           }

    })

  }

  ngOnInit() {
    this.localStorageService.setItem('companyOneId', null);
    this.localStorageService.setItem('companyTwoId', null);
    this.companiesList = [];
    this.start = 0;
    this.getRecommendCompanies();
    const filterMethodSubscription = this.CompanyInsightsService.fetchCompanyFilterData.subscribe((res) => this.getCompanyListData(res))
    this.subscriptions.push(filterMethodSubscription);
  }

  // ngAfterViewInit(): void {
  //   this.observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting) {
  //         // Stop sticking when footer (or last item) is visible
  //         this.renderer.removeClass(this.sidebar.nativeElement, 'fixed');
  //         this.renderer.addClass(this.sidebar.nativeElement, 'absolute');
  //       } else {
  //         // Stick to the top right when footer is not visible
  //         this.renderer.addClass(this.sidebar.nativeElement, 'fixed');
  //         this.renderer.removeClass(this.sidebar.nativeElement, 'absolute');
  //       }
  //     },
  //     {
  //       root: null, // viewport
  //       threshold: 0,
  //     }
  //   );

  //   this.observer.observe(this.stopper.nativeElement);
  // }

  // ngOnDestroy(): void {
  //   if (this.observer) this.observer.disconnect();
  // }
  @HostListener('window:scroll', [])

  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isCollapsed = scrollPosition > 2630;
  }
  onChildButtonClick(value: boolean, type: any) {

    if (type == 'add') {
      this.btnCompareClicked = value
      this.showFooter = value
    } else if (type == 'remove') {
      this.showFooter = value
      this.btnCompareClicked2 = value
      this.btnCompareClicked = false;
      this.oneCompanyAvailableInFooter(value)

    }

  }
  oneCompanyAvailableInFooter(value: boolean) {
    if (value == true) {
      this.showFooter = true
    } else {
      this.showFooter = false
    }
  }
  getFilterData(type, input) {
    const typeaheadObj = {
      startindex: 0,
      resultsize: 10,
      searchviaboolean: true,
      booleanquery: "*",
      industries: this.industrySelectedChips,
      locations: this.locationSelectedChips,
      companysizes: this.companySizesSelectedChips,
      input: input
    }
    if (type == 'industry') {
      typeaheadObj['typeahead'] = 'typeahead_industry'
      this.CompanyInsightsService.getIndustryAggregates(typeaheadObj).subscribe((res: any) => {
        if (res.status == "success") {
          this.industry_typeaheads = res.data.aggs;
        }
      })
    } else if (type == 'companysize') {
      typeaheadObj['typeahead'] = 'typeahead_companysize'
      this.CompanyInsightsService.getIndustryAggregates(typeaheadObj).subscribe((res: any) => {
        if (res.status == "success") {
          this.companysizes_typeaheads = res.data.aggs;
        }
      })
    } else if (type == 'fortune500') {
      this.fortuneFilterClick = !this.fortuneFilterClick;
      this.getRecommendCompanies();
    } else if (type == 'location') {
      typeaheadObj['typeahead'] = 'typeahead_location'
      this.CompanyInsightsService.getIndustryAggregates(typeaheadObj).subscribe((res: any) => {
        if (res.status == "success") {
          this.location_typeaheads = res.data.aggs;
        }
      })
    }
  }

  getInputSearch(event) {
    if (event.type == 'search')
      this.getFilterData('industry', event.searchValue);
    if (event.type == 'apply') {
      if (event.filterType == 'industry')
        this.industrySelectedChips = event.selectedValue;
      else if (event.filterType == 'companysize')
        this.companySizesSelectedChips = event.selectedValue;
      else if (event.filterType == 'location')
        this.locationSelectedChips = event.selectedValue;
      this.start = 0;
      this.getRecommendCompanies();
    } if (event.type == 'reset') {
      if (event.filterType == 'industry')
        this.industrySelectedChips = [];
      else if (event.filterType == 'companysize')
        this.companySizesSelectedChips = [];
      else if (event.filterType == 'location')
        this.locationSelectedChips = [];
      this.start = 0;
      this.getRecommendCompanies();
    }
  }

  getRecommendCompanies() {
    let payload = {
      startindex: this.start,
      resultsize: this.resultsize,
      searchviaboolean: false,
      booleanquery: this.searchValue ? this.searchValue : '*',
      industries: this.industrySelectedChips,
      locations: this.locationSelectedChips,
      companysizes: this.companySizesSelectedChips,
      companybuckettypes: this.fortuneFilterClick == true && this.unicornFilterClick ? ['Fortune500', 'unicorn'] : this.unicornFilterClick == true && !this.fortuneFilterClick ? ['unicorn'] : !this.unicornFilterClick == true && this.fortuneFilterClick ? ['fortune500'] : null,
      companynames: this.searchFrom == 'typeahead' && this.searchValue ? [this.searchValue] : this.searchValue ? [this.searchValue + ".searchastext"] : []
    }
    //
    this.showCompanyListLoader = true;
    this.CompanyInsightsService.getRecommendedcompanies(payload).subscribe((res: any) => {
      if (res.status == "success") {
        this.showCompanyListLoader = false;
        const companies = res.data.results.map(c => ({ ...c, tags: c.tags ? c.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) : [] }));
        if (this.start > 0) {
          this.companiesList = this.companiesList.concat(companies);
        } else {
          this.companiesList = companies;
        }
        this.totalCompanies = res.data.totalresultscount;
      }
    })
  }

  getCompanySearch(event) {
    this.searchValue = event.searchValue;
    this.searchFrom = event.searchFrom;
    const filterData = {
      industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips : [],
      companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips : [],
      locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips : [],
      fortune: this.searchValue ? this.fortuneFilterClick : true,
      unicorn: this.unicornFilterClick,
      search: this.searchValue,
    }
    this.CompanyInsightsService.setCompanyFilterData(filterData);
    this.companiesList = [];
    this.start = 0;
    this.getRecommendCompanies();
  }

  getCompanyListData(response) {
    this.searchValue = response?.search ? response?.search : null;
    this.industrySelectedChips = response.industry;
    this.companySizesSelectedChips = response.companysize;
    this.locationSelectedChips = response.locations;
    this.fortuneFilterClick = response.fortune;
    this.unicornFilterClick = response.unicorn;
    this.companiesList = [];
    this.start = 0;
    this.getRecommendCompanies();
  }

  viewMoreCompanies() {
    this.start = this.start + this.resultsize
    this.resultsize = 7
    this.getRecommendCompanies();
  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  setDataInLocalStorage() {
    const payload = {
      industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips : [],
      companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips : [],
      locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips : [],
      fortune: this.fortuneFilterClick,
      unicorn: this.unicornFilterClick,
      search: this.searchValue,
      searchFrom: this.searchFrom
    }
    const localKey = GlobalService.hash(JSON.stringify(cjson.compress(payload)))
    localStorage.setItem(localKey, JSON.stringify(cjson.compress(payload)));
    const parsedUrl = this.router.parseUrl(this.router.url);

    this.location['go'](parsedUrl.toString().split('?')[0], 'filter=' + encodeURIComponent(localKey));
  }

  loadDataFromLocalStorage(filterData) {
    if (filterData && filterData.industry) {
      this.industrySelectedChips = filterData.industry;
    } else {
      this.industrySelectedChips = [];
    }

    if (filterData && filterData.companysize) {
      this.companySizesSelectedChips = filterData.companysize;
    } else {
      this.companySizesSelectedChips = [];
    }

    if (filterData && filterData.locations) {
      this.locationSelectedChips = filterData.locations;
    } else {
      this.locationSelectedChips = [];
    }

    if (filterData && filterData.fortune != undefined) {
      this.fortuneFilterClick = filterData.fortune;
    } else {
      this.fortuneFilterClick = true;
    }

    if (filterData && filterData.unicorn != undefined) {
      this.unicornFilterClick = filterData.unicorn;
    } else {
      this.unicornFilterClick = false;
    }

    if (filterData && filterData.search) {
      this.searchValue = filterData.search;
      this.CompanyInsightsService.setCompanySearschData(this.searchValue)

    } else {
      this.searchValue = null;
    }

    if (filterData && filterData.searchFrom) {
      this.searchFrom = filterData.searchFrom;
    } else {
      this.searchFrom = null;
    }

    if (filterData && filterData.companyOneId) {
      this.localStorageService.setItem('companyOneId', filterData.companyOneId)
    } else {
      this.localStorageService.setItem('companyOneId', null);
    }

    if (filterData && filterData.companyTwoId) {
      this.localStorageService.setItem('companyTwoId', filterData.companyTwoId)
    } else {
      this.localStorageService.setItem('companyTwoId', null);
    }
    this.getRecommendCompanies();
   }

  private getFilterKeyFromUrl(): string | null {
    const params = new URLSearchParams(location.search);
    return params.get("filter");
  }

    onFilterInput(event) {
    this.searchValue = event?.search ? event?.search : null;
    this.industrySelectedChips = event.industry;
    this.companySizesSelectedChips = event.companysize;
    this.locationSelectedChips = event.locations;
    this.fortuneFilterClick = event.fortune;
    this.unicornFilterClick = event.unicorn;
    this.companiesList = [];
    this.start = 0;
    this.getRecommendCompanies();
  }

}
